import WildAppResource from "./WildAppResource";

class ReferringPlatformAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'referring-platform';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'referrings/platforms';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'displayName',
            'slug',
            'webhookUrl',
            'website',
            'clientUuid',
            'branded',
            'brandHeader',
            'brandFooter',
            'meta',
            'active',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }

}

export default ReferringPlatformAppResource;
